import API from '@/views/Fdc/Apis/'
import Dayjs from 'dayjs'
import { GridLayout, GridItem } from 'vue-grid-layout'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

let mouseXY = { 'x': null, 'y': null }
let DragPos = { 'x': null, 'y': null, 'w': 1, 'h': 1, 'i': null }

export default {
  name: 'customLayout',
  beforeMount () {
    this.initColumns()
  },
  components: {
    GridLayout,
    GridItem
  },
  mounted () {
    document.addEventListener('dragover', function (e) {
      mouseXY.x = e.clientX
      mouseXY.y = e.clientY
    }, false)

    this.getCustomLayout()
  },
  watch: {
    selectedTreeNode: function () {
      this.getEqpHostIpByNode(this.selectedTreeNode)
      this.getParameterListByNode(this.selectedTreeNode)
    }
  },
  methods: {
    /**
     * Column initialize
     */
    initColumns () {
      this.paramColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), field: 'aliasName', flex: 3, checkboxSelection: true, headerCheckboxSelection: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), field: 'paramName', hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), field: 'virtualYn', flex: 1 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SPEC'), field: 'specYn', flex: 1 }
      ]
      this.eventColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), field: 'dateTime', width: 140 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT'), field: 'eventName', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_ID'), field: 'lotId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), field: 'substId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SLOT'), field: 'slot', width: 70 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROD_ID'), field: 'prodId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.OPER_ID'), field: 'operId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.PROCESS'), field: 'procId', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), field: 'carrId', width: 80 }
      ]
      this.alarmColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), field: 'dateTime', width: 140 },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODEL'), field: 'fdModel', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TYPE'), field: 'fdType', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.RESULT'), field: 'fdResult', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'lsl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'lcl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'ucl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'usl', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.ALARM'), field: 'fdAlarm', width: 200 }
      ]
    },
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    getEqpHostIpByNode (node) {
      this.getEqpHostIp(node.detail)
    },
    async getEqpHostIp (node) {
      if (node.moduleId === '') {
        return false
      }
      let eqpIdList = []
      eqpIdList.push(node.eqpId)
      let obj = { eqpId: eqpIdList + '' }
      let data = await API.Common.getEqpHostIps(obj)
      if (data) {
        this.eqpHostIpAddr = (data[node.eqpId] === '') ? 'localhost' : data[node.eqpId]
        console.log(this.eqpHostIpAddr)
      }
    },
    getParameterListByNode (node) {
      this.getParameterList(node.detail)
    },
    async getParameterList (node) {
      if (node.moduleId === '') {
        return false
      }
      let fabList = []
      let eqpIdList = []
      let moduleIdList = []
      fabList.push(node.fab)
      eqpIdList.push(node.eqpId)
      moduleIdList.push(node.moduleId)

      let obj = {
        fab: fabList + '',
        eqpId: eqpIdList + '',
        moduleId: moduleIdList + '',
        useYn: 'Y'
      }

      let data = await API.BaseInfo.getEqpsParams(obj)
      if (data) {
        this.paramList = [...data]
      }
    },
    getDateTime (date) {
      let year = date.substr(0, 4)
      let month = date.substr(4, 2)
      let day = date.substr(6, 2)
      let hour = date.substr(8, 2)
      let minute = date.substr(10, 2)
      let second = date.substr(12, 2)
      let millisecond = date.substr(14, 3)

      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second + '.' + millisecond
    },
    trim (str) {
      return str.replace(/^\s+|\s+$/g, '')
    },
    getChartData (dataToChart, traceData) {
      let date = Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
      this.setMinMax(date)
      traceData['x'] = date
      dataToChart.forEach((data) => {
        let tempStr = data.paramName
        traceData[tempStr] = parseFloat(data.paramVal)
        if (this.selectedParameter === data.paramName) {
          traceData['lsl'] = data.lsl
          traceData['usl'] = data.usl
          traceData['lcl'] = data.lcl
          traceData['ucl'] = data.ucl
        }
        this.chartData.push(traceData)
      })
      return this.chartData.slice()
    },
    setMinMax (x) {
      let time = 1000 * 60 * 5
      // xMin을 newPoint의 시간으로부터 1분간으로 설정
      if (x - this.xMin > time) {
        this.xMin = x - time
        this.chartData.shift()
      }
      // xMax는 새로 들어온 포인트의 시간으로 설정
      this.xMax = (x > this.xMax) ? x : this.xMax
    },
    async connect (isRealTime) {
      if (isRealTime) {
        // this.realTimeChart.collectionView.refresh()
        this.chartTitle = ''
        this.dataToChart = []
        // this.seriesData = []
        // this.chartData = []
        this.eventList = []
        this.alarmList = []
        this.stepList = []
        this.selectedParameter = null
        this.checkedDataToChartRows = []
        // this.yMax = null
        // this.yMin = null

        let checkedRows = this.$refs.paramGrid.gridApi.getSelectedRows()
        if (checkedRows.length === 0) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', [this.$t('fdc.COMMON.LABEL.PARAMETER')]))
          return true
        }

        this.isRealTime = false
        // this.isPushServiceStart = true

        var payload
        if (this.selectedTreeNode) {
          this.chartTitle = this.selectedTreeNode.detail.moduleId
          payload = {
            roomId: this.selectedTreeNode.detail.fab + this.selectedTreeNode.detail.eqpId + this.selectedTreeNode.detail.moduleId,
            hostIp: this.eqpHostIpAddr
          }
        } else {
          this.chartTitle = this.nodeObj.moduleId
          payload = {
            roomId: this.nodeObj.fab + this.nodeObj.eqpId + this.nodeObj.moduleId,
            hostIp: this.eqpHostIpAddr
          }
        }

        this.paramListDisabled(true)

        // real time room 조회 및 생성
        let response = await API.Monitor.startRealtimeMonitor(payload)
        response.hostIp = this.eqpHostIpAddr
        console.log('Real Time Start Result', response)
        this.requestResult = response

        if (response.result) {
          this.ws = API.Monitor.connectStomp()
          // this.ws = API.FdcRealTime.connectStomp()
          var selectTreeNode = this.selectedTreeNode ? this.selectedTreeNode.detail : this.nodeObj
          var subUrl = selectTreeNode.fab + selectTreeNode.eqpId + selectTreeNode.moduleId
          let self = this

          this.checkedDataToChartRows = checkedRows.filter(row => row.specYn === 'Y')
          if (checkedRows.length === 1 && this.checkedDataToChartRows.length === 1) {
            this.selectedParameter = this.checkedDataToChartRows[0].paramName
          }

          this.ws.connect({}, function () {
            // trace data process
            self.ws.subscribe('/fdc/rts/trace/' + subUrl, function (message) { self.traceDataProcess(message) })

            // event data process
            self.ws.subscribe('/fdc/rts/event/' + subUrl, function (message) { self.eventDataProcess(message) })
          })
        } else {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.FAILED_EXEC_REQ'))
        }
        let traces = []
        // checkedRows.filter(row => row.specYn === 'Y').forEach(e => {
        checkedRows.forEach(e => {
          this.traceIndexMapper[e.paramName] = traces.length
          traces.push({
            name: e.paramName,
            mode: 'lines',
            x: [],
            y: [],
            text: [],
            hovertemplate: '<b>Time:</b>%{x}<br><b>LOT ID:</b> %{text.lotId}<br><b>Substrate:</b> %{text.substrate}<br><b>Recipe:</b> %{text.recipeId}<br><b>Step:</b> %{text.step}<br><b>Parameter:</b> %{text.paramName}<br><b>Value:</b> %{text.paramVal}'
          })
        })

        this.traceIndexMapper['LSL'] = traces.length
        traces.push({
          name: 'LSL',
          x: [],
          y: [],
          text: [],
          mode: 'lines',
          line: { color: 'red' },
          fill: 'tonexty',
          fillcolor: 'rgba(255, 165, 0, 0)',
          connectgaps: false,
          hovertemplate: '<b>Time:</b> %{x}<br><b>Spec:</b> %{y}'
        })
        this.traceIndexMapper['LCL'] = traces.length
        traces.push({
          name: 'LCL',
          x: [],
          y: [],
          text: [],
          mode: 'lines',
          line: { color: 'orange' },
          fill: 'tonexty',
          fillcolor: 'rgba(255, 165, 0, 0.05)',
          connectgaps: false,
          hovertemplate: '<b>Time:</b> %{x}<br><b>Spec:</b> %{y}'
        })
        this.traceIndexMapper['UCL'] = traces.length
        traces.push({
          name: 'UCL',
          x: [],
          y: [],
          text: [],
          mode: 'lines',
          line: { color: 'orange' },
          fill: 'tonexty',
          fillcolor: 'rgba(0, 128, 0, 0.05)',
          connectgaps: false,
          hovertemplate: '<b>Time:</b> %{x}<br><b>Spec:</b> %{y}'
        })
        this.traceIndexMapper['USL'] = traces.length
        traces.push({
          name: 'USL',
          x: [],
          y: [],
          text: [],
          mode: 'lines',
          line: { color: 'red' },
          fill: 'tonexty',
          fillcolor: 'rgba(255, 165, 0, 0.05)',
          connectgaps: false,
          hovertemplate: '<b>Time:</b> %{x}<br><b>Spec:</b> %{y}'
        })

        // let traces = [
        //   // { name: 'USL', x: [], y: [], mode: 'lines', line: { color: 'red' }, fill: 'tonexty', fillcolor: 'rgba(255, 0, 0, 0.1)' },
        //   // { name: 'UCL', x: [], y: [], mode: 'lines', line: { color: 'orange' }, fill: 'tonexty', fillcolor: 'rgba(255, 0, 0, 0.1)' },
        //   // { name: 'LCL', x: [], y: [], mode: 'lines', line: { color: 'orange' }, fill: 'tonexty', fillcolor: 'rgba(255, 0, 0, 0.1)' },
        //   // { name: 'LSL', x: [], y: [], mode: 'lines', line: { color: 'red' }, fill: 'tonexty', fillcolor: 'rgba(255, 0, 0, 0.1)' }
        //   { name: 'USL', x: [], y: [], mode: 'lines', line: { color: 'red' }, fill: 'None' },
        //   { name: 'UCL', x: [], y: [], mode: 'lines', line: { color: 'orange' }, fill: 'tonexty', fillcolor: 'rgba(255, 0, 0, 0.1)' },
        //   { name: 'LCL', x: [], y: [], mode: 'lines', line: { color: 'orange' }, fill: 'tonexty', fillcolor: 'rgba(255, 165, 0, 0.1)' },
        //   { name: 'LSL', x: [], y: [], mode: 'lines', line: { color: 'red' }, fill: 'tonexty', fillcolor: 'rgba(255, 0, 0, 0.1)' }
        // ])
        // checkedRows.filter(row => row.specYn === 'Y').forEach(e => {
        //   this.traceIndexMapper[e.paramName] = traces.length
        //   traces.push({
        //     name: e.paramName,
        //     mode: 'lines',
        //     x: [],
        //     y: []
        //   })
        // })
        this.traceIndexMapper['WARNING'] = traces.length
        traces.push({
          name: 'Warning',
          x: [],
          y: [],
          text: [],
          mode: 'markers',
          marker: { color: 'orange' },
          hovertemplate: '<b>LOT ID:</b> %{text.lotId}<br><b>Substrate:</b> %{text.substrate}<br><b>Recipe:</b> %{text.recipeId}<br><b>Step:</b> %{text.step}<br><b>Parameter:</b> %{text.paramName}<br><b>Value:</b> %{text.paramVal}<br><b>Result:</b> %{text.result}<br><b>Spec:</b> %{text.usl}, %{text.ucl}, %{text.lcl}, %{text.lsl}<br><b>Alarm:</b> %{text.alarmMessage}<extra></extra>'
        })
        this.traceIndexMapper['FAULT'] = traces.length
        traces.push({
          name: 'Fault',
          x: [],
          y: [],
          text: [],
          mode: 'markers',
          marker: { color: 'red' },
          hovertemplate: '<b>LOT ID:</b> %{text.lotId}<br><b>Substrate:</b> %{text.substrate}<br><b>Recipe:</b> %{text.recipeId}<br><b>Step:</b> %{text.step}<br><b>Parameter:</b> %{text.paramName}<br><b>Value:</b> %{text.paramVal}<br><b>Result:</b> %{text.result}<br><b>Spec:</b> %{text.usl}, %{text.ucl}, %{text.lcl}, %{text.lsl}<br><b>Alarm:</b> %{text.alarmMessage}<extra></extra>'
        })

        let layout = {
          xaxis: {
            type: 'date',
            // fixedrange: true,
            tickformat: '%H:%M:%S.%3f',
            range: [new Date(), Dayjs().add(this.interval, 'ms').toDate()]
          },
          hoverlabel: {
            align: 'left'
          },
          shapes: [],
          annotations: [],
          hovermode: 'closest'
        }
        let config = {
          responsive: true,
          displayModeBar: true,
          displaylogo: false
        }
        BriqueChart.newPlot('realTimeChart', traces, layout, config)
        this.isFirst = true
      } else {
        this.isRealTime = true
        // this.chartTitle = ''
        // this.dataToChart = []
        // this.seriesData = []
        // this.chartData = []
        // this.eventList = []
        // this.alarmList = []
        // this.stepList = []
        // this.selectedParameter = null
        // this.checkedDataToChartRows = []
        // this.yMax = null
        // this.yMin = null
        this.paramListDisabled(false)
        this.ws.disconnect()
        // this.lotId = ''
        // this.subStrId = ''

        await API.Monitor.stopRealtimeMonitor(this.requestResult)
      }
    },
    // trace data 처리
    traceDataProcess (message) {
      let traceData = JSON.parse(message.body)
      // let traceList = JSON.parse(message.body)
      let checkedRows = this.$refs.paramGrid.gridApi.getSelectedRows()
      let lsl = 0
      let usl = 0
      let ucl = 0
      let lcl = 0
      // let yMin = this.yMin
      // let yMax = this.yMax
      let alarmMessage = null
      // let maxUsl = null
      // let minLsl = null
      let beforeStep = this.beforeStep

      this.checkedDataToChartRows = checkedRows.filter(row => row.specYn === 'Y')

      if (checkedRows.length === 1 && this.checkedDataToChartRows.length === 1 && this.selectedParameter !== null) {
        this.selectedParameter = this.checkedDataToChartRows[0].paramName
      }

      // traceList.forEach(traceData => {
      this.deleteDataOverInterval(traceData)

      // if (this.isPushServiceStart) {
      //   this.xMin = Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
      //   this.xMax = Dayjs(this.getDateTime(traceData.dateTime)).add(this.selectedInterval, 'seconds').valueOf()
      //   this.isPushServiceStart = false
      // }

      let chartData = {
        dateTime: traceData.dateTime,
        fabId: traceData.fabId,
        eqpId: traceData.eqpId,
        moduleId: traceData.moduleId,
        lotId: traceData.lotDatas.lotId,
        recipeId: traceData.lotDatas.recipeId,
        step: traceData.traceDatas.step,
        paramDatas: traceData.paramDatas,
        substDatas: traceData.substDatas
      }

      // let seriesData = []
      this.dataToChart = traceData.paramDatas.filter((param) => {
        for (let checkedData of checkedRows) {
          if (checkedData.paramName === this.trim(param.paramName)) {
            // if (yMax === null) yMax = parseFloat(param.paramVal)
            // if (yMin === null) yMin = parseFloat(param.paramVal)

            // if (parseFloat(param.paramVal) > yMax) {
            //   yMax = parseFloat(param.paramVal)
            // }

            // if (parseFloat(param.paramVal) < yMin) {
            //   yMin = parseFloat(param.paramVal)
            // }

            // FIXME: spec data 처리 방안 필요
            // fdDatas를 이용한 Fault 로직 처리
            let fdDatas = [...param.fdDatas]
            if (fdDatas.length > 0) {
              fdDatas.forEach(fdData => {
                // if (this.selectedParameter !== null && fdData.fdModel === this.selectedParameter) {
                //   if (maxUsl === null) maxUsl = parseFloat(fdData.fdSpec.usl)
                //   if (maxUsl !== null && parseFloat(fdData.fdSpec.usl) > maxUsl) maxUsl = parseFloat(fdData.fdSpec.usl)
                //   if (minLsl === null) minLsl = parseFloat(fdData.fdSpec.lsl)
                //   if (minLsl !== null && parseFloat(fdData.fdSpec.lsl) < minLsl) minLsl = parseFloat(fdData.fdSpec.lsl)
                // }

                usl = Math.round(parseFloat(fdData.fdSpec.usl).toFixed(4) * 10000) / 10000.0
                ucl = Math.round(parseFloat(fdData.fdSpec.ucl).toFixed(4) * 10000) / 10000.0
                lcl = Math.round(parseFloat(fdData.fdSpec.lcl).toFixed(4) * 10000) / 10000.0
                lsl = Math.round(parseFloat(fdData.fdSpec.lsl).toFixed(4) * 10000) / 10000.0

                let status = fdData.fdResult.toUpperCase()
                switch (status) {
                  case 'SAFE':
                    break
                  case 'FAULT':
                  case 'WARNING':
                    this.alarmList.unshift({
                      'dateTime': this.getDateTime(traceData.dateTime),
                      'fdModel': fdData.fdModel,
                      'fdType': fdData.fdType,
                      'usl': fdData.fdSpec.usl,
                      'ucl': fdData.fdSpec.ucl,
                      'lcl': fdData.fdSpec.lcl,
                      'lsl': fdData.fdSpec.lsl,
                      'fdResult': fdData.fdResult,
                      'fdAlarm': fdData.fdAlarm
                    })

                    alarmMessage = fdData.fdAlarm
                    break
                }
                param.usl = usl
                param.ucl = ucl
                param.lcl = lcl
                param.lsl = lsl
                param.status = status
                param.alarmMessage = alarmMessage
              })
            }

            return true
          }
        }
      })

      // let length = this.$refs.paramGrid.checkedRows.filter(row => row.specYn === 'Y').length
      let length = this.$refs.paramGrid.gridApi.getSelectedRows().length
      let time = Dayjs(traceData.dateTime).toDate()
      let x = new Array(length + 6).fill(0).map(e => [time])
      let y = new Array(length + 6).fill(0).map(e => [NaN])
      let text = new Array(length + 6).fill(0).map(e => [{}])
      let traceIndexes = new Array(length + 6).fill(0).map((e, i) => i)

      // chartData setting
      let date = Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
      // this.setMinMax(date)
      chartData['x'] = date
      this.dataToChart.forEach((data) => {
        let paramName = data.paramName
        chartData[paramName] = parseFloat(data.paramVal)

        // FIXME: spec data 처리 방안 필요
        if (this.selectedParameter === data.paramName) {
          chartData['usl'] = data.usl
          chartData['ucl'] = data.ucl
          chartData['lcl'] = data.lcl
          chartData['lsl'] = data.lsl
          y[this.traceIndexMapper['USL']] = [data.usl]
          y[this.traceIndexMapper['UCL']] = [data.ucl]
          y[this.traceIndexMapper['LCL']] = [data.lcl]
          y[this.traceIndexMapper['LSL']] = [data.lsl]
        }
        if (data.status === 'FAULT') {
          y[this.traceIndexMapper['FAULT']] = [data.paramVal]
          text[this.traceIndexMapper['FAULT']] = [{
            lotId: traceData.lotDatas.lotId,
            substrate: traceData.substDatas[0].substId,
            recipeId: traceData.lotDatas.recipeId,
            step: traceData.traceDatas.step,
            paramName: data.paramName,
            paramVal: data.paramVal,
            result: data.status,
            usl: data.usl,
            ucl: data.ucl,
            lcl: data.lcl,
            lsl: data.lsl,
            alarmMessage: data.alarmMessage
          }]
        }
        if (data.status === 'WARNING') {
          y[this.traceIndexMapper['WARNING']] = [data.paramVal]
          text[this.traceIndexMapper['WARNING']] = [{
            lotId: traceData.lotDatas.lotId,
            substrate: traceData.substDatas[0].substId,
            recipeId: traceData.lotDatas.recipeId,
            step: traceData.traceDatas.step,
            paramName: data.paramName,
            paramVal: data.paramVal,
            result: data.status,
            usl: data.usl,
            ucl: data.ucl,
            lcl: data.lcl,
            lsl: data.lsl,
            alarmMessage: data.alarmMessage
          }]
        }

        let traceIndex = this.traceIndexMapper[data.paramName]
        y[traceIndex] = [data.paramVal]
        text[traceIndex] = [{
          lotId: traceData.lotDatas.lotId,
          substrate: traceData.substDatas[0].substId,
          recipeId: traceData.lotDatas.recipeId,
          step: traceData.traceDatas.step,
          paramName: data.paramName,
          paramVal: data.paramVal
        }]
        // if (this.text[traceIndex] === undefined) this.text[traceIndex] = []
        // this.text[traceIndex].push(`Lot ID: ${traceData.lotId}<br>Substrate: ${traceData.substDatas[0].substId}<br>Recipe: ${traceData.recipeId}<br>Step: ${traceData.traceDatas.step}`)
        // BriqueChart.restyle(document.querySelector('#realTimeChart'), { 'text': this.text[traceIndex] }, [traceIndex], false)
      })
      BriqueChart.extendTraces('realTimeChart', { x: x, y: y, text: text }, traceIndexes, 1000)

      if (this.isFirst) {
        this.isFirst = false
        let layout = document.querySelector('#realTimeChart').layout
        layout.xaxis.range = [Dayjs(chartData.x).toDate(), Dayjs(chartData.x).add(this.interval, 'ms').toDate()]
        BriqueChart.relayout('realTimeChart', layout, false)
      }

      let layout = document.querySelector('#realTimeChart').layout
      if (Dayjs(chartData.x).isBefore(Dayjs(Dayjs(layout.xaxis.range[1])))) {
        layout.xaxis.range = [Dayjs(layout.xaxis.range[0]).toDate(), Dayjs(layout.xaxis.range[0]).add(this.interval, 'ms').toDate()]
      } else {
        layout.xaxis.range = [Dayjs(chartData.x).subtract(this.interval, 'ms').toDate(), Dayjs(chartData.x).toDate()]
      }
      BriqueChart.relayout('realTimeChart', layout, false)

      // append new points, remove old points
      // let arr = this.realTimeChart.collectionView.sourceCollection
      // arr.push(chartData)
      // this.realTimeChart.collectionView.refresh()

      // this.checkedDataToChartRows = [...this.dataToChart]
      // if (this.checkedDataToChartRows.length === 1) {

      // this.getChartData(this.dataToChart, traceData)

      if (beforeStep === null) {
        beforeStep = traceData.traceDatas.step
        this.drawStepAnnotation(traceData)
      } else if (beforeStep !== null && beforeStep !== traceData.traceDatas.step) {
        beforeStep = traceData.traceDatas.step
        this.drawStepAnnotation(traceData)
      }

      // })
      // if (parseFloat(maxUsl) > yMax) {
      //   let calGapUsl = parseFloat(maxUsl - yMax)
      //   yMax = (yMax + calGapUsl)
      // }
      // if (parseFloat(minLsl) < yMin) {
      //   let calGapLsl = parseFloat(yMin - minLsl)
      //   yMin = (yMin - calGapLsl)
      // }

      // if (yMax !== this.yMax) this.yMax = (yMax + ((yMax - yMin) * 0.2))
      // if (yMin !== this.yMin) this.yMin = (yMin - ((yMax - yMin) * 0.2))
    },
    /**
     * Chart에 step 구분 line annotation draw
     * @param {*} traceData trace data
     */
    drawStepAnnotation (traceData) {
      this.stepList.unshift({
        'step': traceData.traceDatas.step,
        'annoDateTime': Dayjs(this.getDateTime(traceData.dateTime)).valueOf()
      })
      this.beforeStep = traceData.traceDatas.step

      let from = Dayjs(traceData.dateTime).subtract(this.interval, 'ms').toDate()
      let to = Dayjs(traceData.dateTime).toDate()
      this.shapes = this.shapes.filter(e => Dayjs(e.x).isAfter(Dayjs(from)))
      this.shapes.push({
        type: 'line',
        xref: 'x',
        x0: to,
        x1: to,
        yref: 'paper',
        y0: 0.05,
        y1: 0.95,
        line: { color: 'gray' }
      })
      this.annotations = this.annotations.filter(e => Dayjs(e.x).isAfter(Dayjs(from)))
      this.annotations.push({
        xref: 'x',
        x: to,
        yref: 'paper',
        y: 0.05,
        yanchor: 'top',
        // yshift: eventData.eventName.includes('START') ? 0 : 15,
        text: traceData.traceDatas.step,
        showarrow: false
      })
      let layout = document.querySelector('#realTimeChart').layout
      layout.annotations = this.isLotShow ? this.annotations : []
      layout.shapes = this.isLotShow ? this.shapes : []
      BriqueChart.relayout('realTimeChart', layout, false)
    },
    // event data 처리
    eventDataProcess (message) {
      let eventData = JSON.parse(message.body)

      // LotId, SubStrId 차트에 어노테이션 표시
      // this.lotId = eventData.lotId
      // this.subStrId = eventData.substDatas[0].substId
      let eventObj = {
        'dateTime': this.getDateTime(eventData.dateTime),
        'eventName': eventData.eventDatas.eventName,
        'lotId': eventData.lotDatas.lotId,
        'substId': eventData.substDatas[0].substId,
        'slot': eventData.substDatas[0].slotNo,
        'recipeId': eventData.lotDatas.recipeId,
        'prodId': eventData.lotDatas.prodId,
        'operId': eventData.lotDatas.operId,
        'procId': eventData.lotDatas.procId,
        'carrId': eventData.lotDatas.carrId
      }
      // if (eventData.eventName.indexOf('START') > -1) {
      //   eventObj.annoDateTime = Dayjs(this.getDateTime(eventData.dateTime)).valueOf()
      //   eventObj.annoValue = this.yMax
      // }
      this.eventList.unshift(eventObj)

      if (this.isFirst) {
        this.isFirst = false
        let layout = document.querySelector('#realTimeChart').layout
        layout.xaxis.range = [Dayjs(eventData.dateTime).toDate(), Dayjs(eventData.dateTime).add(this.interval, 'ms').toDate()]
        BriqueChart.relayout('realTimeChart', layout, false)
      }

      if (eventData.eventDatas.eventName.indexOf('START') > -1) {
        let from = Dayjs(eventData.dateTime).subtract(this.interval, 'ms').toDate()
        let to = Dayjs(eventData.dateTime).toDate()
        this.shapes = this.shapes.filter(e => Dayjs(e.x).isAfter(Dayjs(from)))
        this.shapes.push({
          type: 'line',
          xref: 'x',
          x0: to,
          x1: to,
          yref: 'paper',
          y0: 0,
          y1: 0.95,
          line: { color: 'black' }
        })
        this.annotations = this.annotations.filter(e => Dayjs(e.x).isAfter(Dayjs(from)))
        this.annotations.push({
          xref: 'x',
          x: to,
          yref: 'paper',
          y: 0.95,
          yanchor: 'bottom',
          yshift: eventData.eventDatas.eventName.includes('START') ? 0 : 15,
          text: eventData.lotDatas.lotId + '<br>' + eventData.substDatas[0].substId,
          showarrow: false
        })
      }
      this.lotShow()
    },
    lotShow () {
      let layout = document.querySelector('#realTimeChart').layout
      layout.annotations = this.isLotShow ? this.annotations : []
      layout.shapes = this.isLotShow ? this.shapes : []
      BriqueChart.relayout('realTimeChart', layout, false)
    },
    // parameter list check box control
    paramListDisabled (value) {
      document.getElementsByClassName('select-all')[0].disabled = value
      let checkBoxList = document.getElementsByClassName('select-row')
      for (var i = 0; i < checkBoxList.length; i++) {
        checkBoxList[i].disabled = value
      }
    },
    // 5분 지난 data 삭제
    deleteDataOverInterval (traceData) {
      // 5분 이상 지난 Alarm은 제거
      if (this.alarmList.length > 0) {
        this.alarmList = this.alarmList.filter((alarm) => {
          if (Dayjs(this.getDateTime(traceData.dateTime)).valueOf() - Dayjs(alarm.dateTime).valueOf() < this.interval) {
            return alarm
          }
        })
      }

      // 5분 이상 지난 Event는 제거
      if (this.eventList.length > 0) {
        this.eventList = this.eventList.filter((event) => {
          if (Dayjs(this.getDateTime(traceData.dateTime)).valueOf() - Dayjs(event.dateTime).valueOf() < this.interval) {
            return event
          }
        })
      }

      // 5분 이상 지난 Step은 제거
      if (this.stepList.length > 0) {
        this.stepList = this.stepList.filter((event) => {
          if (Dayjs(this.getDateTime(traceData.dateTime)).valueOf() - Dayjs(event.annoDateTime).valueOf() < this.interval) {
            return event
          }
        })
      }
    },
    itemFormatter (engine, hitInfo, defaultRenderer) {
      let ht = hitInfo
      ht.item.paramDatas.forEach(param => {
        if (ht.name === param.paramName && param.status === 'WARNING') {
          engine.stroke = 'orange'
          engine.strokeWidth = 6
          engine.fill = 'rgb(255,127,0)'
        }

        if (ht.name === param.paramName && param.status === 'FAULT') {
          engine.stroke = 'red'
          engine.strokeWidth = 6
          engine.fill = 'rgb(255,0,0)'
        }
      })
      defaultRenderer()
    },
    tooltipContent (hti) {
      if (!hti.name) {
        return false
      }

      let item = hti.item
      let result = ''
      let alarmMessage = ''
      let lsl = null
      let usl = null
      let lcl = null
      let ucl = null

      hti.item.paramDatas.forEach(param => {
        if (hti.name === param.paramName && param.status === 'WARNING') {
          result = 'WARNING'
          alarmMessage = param.alarmMessage
          lsl = param.lsl
          usl = param.usl
          lcl = param.lcl
          ucl = param.ucl
        } else if (hti.name === param.paramName && param.status === 'FAULT') {
          result = 'FAULT'
          alarmMessage = param.alarmMessage
          lsl = param.lsl
          usl = param.usl
          lcl = param.lcl
          ucl = param.ucl
        } else if (hti.name === param.paramName && param.status === 'SAFE') {
          result = 'SAFE'
          lsl = param.lsl
          usl = param.usl
          lcl = param.lcl
          ucl = param.ucl
        }
      })

      let tooltipText = `<b>Time</b>: ${this.getDateTime(item.dateTime)}</br>
        <b>Lot ID</b>: ${item.lotId}</br>
        <b>Substrate</b>: ${item.prodMtrls[0].prodMtrlId}</br>
        <b>Recipe</b>: ${item.recipeId}</br>
        <b>Step</b>: ${item.step}</br>
        <b>Parameter</b>: ${hti.series.binding}</br>
        <b>Value</b>: ${hti.value}</br>`

      if (lsl === null && usl === null && lcl === null && ucl === null) {
        return tooltipText
      } else {
        return tooltipText + `<b>Result</b>: ${result}</br>
          <b>Spec</b>: ${lsl}, ${lcl}, ${ucl}, ${usl}</br>
          <b>Alarm</b>: ${alarmMessage}</br>`
      }
    },
    // layout 관련 function
    // drag & drop
    drag: function (value) {
      let parentRect = document.getElementById('content').getBoundingClientRect()
      let mouseInGrid = false
      if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
        mouseInGrid = true
      }
      if (mouseInGrid === true && (this.layout.findIndex(item => item.i === 'drop')) === -1) {
        this.layout.push({
          x: (this.layout.length * 2) % (this.colNum || 12),
          y: this.layout.length + (this.colNum || 12), // puts it at the bottom
          w: 1,
          h: 1,
          i: 'drop'
        })
      }
      let index = this.layout.findIndex(item => item.i === 'drop')
      if (index !== -1) {
        try {
          this.$refs.gridlayout.$children[this.layout.length].$refs.item.style.display = 'none'
        } catch {
          console.log('error')
        }
        let el = this.$refs.gridlayout.$children[index]
        el.dragging = { 'top': mouseXY.y - parentRect.top, 'left': mouseXY.x - parentRect.left }
        let newPos = el.calcXY(mouseXY.y - parentRect.top, mouseXY.x - parentRect.left)
        if (mouseInGrid === true) {
          this.$refs.gridlayout.dragEvent('dragstart', 'drop', newPos.x, newPos.y, 1, 1)
          DragPos.i = String(index)
          DragPos.x = this.layout[index].x
          DragPos.y = this.layout[index].y
        }
        if (mouseInGrid === false) {
          this.$refs.gridlayout.dragEvent('dragend', 'drop', newPos.x, newPos.y, 1, 1)
          this.layout = this.layout.filter(obj => obj.i !== 'drop')
        }
      }
    },
    dragend: function (value) {
      console.log('dragend', value)
      let parentRect = document.getElementById('content').getBoundingClientRect()
      let mouseInGrid = false
      if (((mouseXY.x > parentRect.left) && (mouseXY.x < parentRect.right)) && ((mouseXY.y > parentRect.top) && (mouseXY.y < parentRect.bottom))) {
        mouseInGrid = true
      }
      if (mouseInGrid === true) {
        alert(`Dropped element props:\n${JSON.stringify(DragPos, ['x', 'y', 'w', 'h'], 2)}`)

        this.$refs.gridlayout.dragEvent('dragend', 'drop', DragPos.x, DragPos.y, 1, 1)
        this.layout = this.layout.filter(obj => obj.i !== 'drop')

        if (value === 'EQPTree') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 2, 'h': 6, 'i': 'EQPTree' })
        } else if (value === 'ParamList') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 2, 'h': 4, 'i': 'ParamList' })
        } else if (value === 'SearchButton') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 2, 'h': 2, 'i': 'SearchButton' })
        } else if (value === 'RealTimeChart') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 4, 'h': 6, 'i': 'RealTimeChart' })
        } else if (value === 'EventGrid') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 4, 'h': 6, 'i': 'EventGrid' })
        } else if (value === 'FaultGrid') {
          this.layout.push({ 'x': DragPos.x, 'y': DragPos.y, 'w': 4, 'h': 6, 'i': 'FaultGrid' })
        }
        // UNCOMMENT below if you want to add a grid-item
        /*
        this.layout.push({
            x: DragPos.x,
            y: DragPos.y,
            w: 1,
            h: 1,
            i: DragPos.i,
        });
        this.$refs.gridLayout.dragEvent('dragend', DragPos.i, DragPos.x,DragPos.y,1,1);
        try {
            this.$refs.gridLayout.$children[this.layout.length].$refs.item.style.display="block";
        } catch {
        }
        */
      }
    },
    layoutUpdatedEvent () {
      console.log('this.layout', this.layout)
    },
    // 2022.03 API Refactoring - getCustomLayout API 제거
    async getCustomLayout () {
      // let payload = {
      //   pageName: 'Custom Layout',
      //   userId: 'admin'
      // }
      // await API.FdcManagement.getCustomLayout(payload, this.getCustomLayoutCallback)
    },
    getCustomLayoutCallback (response) {
      if (response.status === 200 && response.data) {
        console.log('response.data', response.data)
        var json = JSON.parse(response.data.pageLayout)
        console.log(json)
        this.layout = json
      }
    }
  },
  data () {
    return {
      layout: [],
      index: 0,
      // theChart: null,
      selectedParameter: null, // 선택된 parameter (spec line 관련)
      isPushServiceStart: false, // Real Time 시작 여부
      // treeNodes: [],
      // seriesData: [], // Chart Series Data
      checkedRows: [], // 선택된 Parameter 목록 배열
      checkedDataToChartRows: [], // Display Spec 목록 배열
      dataToChart: [], // chart data
      paramColumns: [], // Parameter List grid column 배열
      eventColumns: [], // Event List grid column 배열
      alarmColumns: [], // Fault List grid column 배열
      defaultColDef: {
        // minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      // paramColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.ALIAS_NAME'), binding: 'aliasName', width: '4*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PARAM_NAME'), binding: 'paramName', readOnly: true, visible: false },
      //   { label: this.$t('fdc.COMMON.COLUMN.VIRTUAL'), binding: 'virtualYn', width: '1*', readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SPEC'), binding: 'specYn', width: '1*', readOnly: true }
      // ], // Parameter List grid column 배열
      // eventColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), binding: 'dateTime', width: 140, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.EVENT'), binding: 'eventName', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LOT_ID'), binding: 'lotId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SUBST_ID'), binding: 'substId', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.SLOT'), binding: 'slot', width: 70, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RECIPE'), binding: 'recipeId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROD_ID'), binding: 'prodId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.OPER_ID'), binding: 'operId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.PROCESS'), binding: 'procId', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.CARRIER_ID'), binding: 'carrId', width: 80, readOnly: true }
      // ], // Event List grid column 배열
      // alarmColumns: [
      //   { label: this.$t('fdc.COMMON.COLUMN.DATE_TIME'), binding: 'dateTime', width: 140, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.MODEL'), binding: 'fdModel', width: 100, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.TYPE'), binding: 'fdType', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.RESULT'), binding: 'fdResult', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LSL'), binding: 'lsl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.LCL'), binding: 'lcl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.UCL'), binding: 'ucl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.USL'), binding: 'usl', width: 80, readOnly: true },
      //   { label: this.$t('fdc.COMMON.COLUMN.ALARM'), binding: 'fdAlarm', width: 200, readOnly: true }
      // ], // Fault List grid column 배열
      ws: null, // Websocket 객체
      isRealTime: true, // Real Time 사용 중인지 여부
      // tempObj: null,
      nodeObj: null, // EQP Status Monitor 화면 연동 시 사용 하는 EQP Tree node data
      selectedTreeNode: null, // 선택된 EQP Tree node
      paramList: [], // Parameter List 배열
      eventList: [], // Event List 배열
      alarmList: [], // Fault List 배열
      stepList: [], // Step List 배열
      // chartData: [], // Chart data
      chartTitle: '', // Chart title
      // lotId: '',
      // subStrId: '',
      // xMin: null, // Chart x축 min 값
      // xMax: null, // Chart x축 max 값
      // yMin: null, // Chart y축 min 값
      // yMax: null, // Chart y축 max 값
      // interval: 5 * 60 * 1000,
      beforeStep: null, // 이전 step 정보
      requestResult: null, // real time start에 대한 요청 정보 저장
      selectedInterval: 120, // interval 정보
      isLotShow: false, // lot 정보 표시 여부
      eqpHostIpAddr: '', // HOST IP 정보
      traceIndexMapper: {},
      isFirst: false,
      annotations: [],
      shapes: [],
      text: []
    }
  }
}
